<template>
  <div>
    <audio ref="audio" src="../file.mp3" preload loop muted></audio>
    <nav>
      <ul>
        <li><router-link to="/">Ingenieria Multimedia</router-link></li>
        <li>
          <div class="tooltip">
            <a class="info" href="#">Información</a>
            <span class="tooltiptext"
              ><b>Universidad Militar Nueva Granada</b> <br />
              Este es un proyecto de <b>Ingenieria Multimedia</b> realizado para
              la electiva de <b>Multimedia Educativa</b> relizado por <br />
              <b>Santiago Forero y Cesar Peña</b> <br />
              donde se busca crear alternativas de aprendizaje frente a
              conceptos de computación gráfica.
            </span>
          </div>

          <a
            href="https://documenter.getpostman.com/view/16858046/UyxjG6Ci"
            target="_blanck"
          >
            <font-awesome-icon class="icon" icon="fa-solid fa-hat-wizard" />
          </a>

          <font-awesome-icon class="icon" icon="fa-solid fa-gear" />
          <font-awesome-icon
            v-if="expandir"
            @click="launchFullScreen()"
            class="icon"
            icon="fa-solid fa-expand"
          />
          <font-awesome-icon
            v-else
            @click="cancelFullScreen()"
            class="icon"
            icon="fa-solid fa-minimize"
          />
          <font-awesome-icon
            v-if="play"
            class="icon"
            icon="fa-solid fa-volume-off"
            @click="launchAudio()"
          />
          <font-awesome-icon
            v-else
            class="icon"
            icon="fa-solid fa-volume-high"
            @click="muteAudio()"
          />
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
export default {
  name: "BarraHerammientas",
  data() {
    return {
      expandir: true,
      play: false,
    };
  },
  methods: {
    launchFullScreen() {
      let element = document.documentElement;
      if (element.requestFullScreen) {
        element.requestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      }
      this.expandir = false;
    },
    // Lanza en pantalla completa en navegadores que lo soporten
    cancelFullScreen() {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
      this.expandir = true;
    },
    launchAudio() {
      this.play = this.$launchAudio(this.$refs.audio);
      console.log(this.play);
    },
    muteAudio() {
      this.play = this.$muteAudio(this.$refs.audio);
      console.log(this.play);
    },
    onClick() {
      console.log("Movio");
      setTimeout(() => {
        this.launchAudio();
      }, 1000);
    },
  },
  created() {
    document.addEventListener("click", this.onClick());
  },
};
</script>
<style scoped>
ul {
  position: absolute;
  bottom: 0;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  font-size: 1.4rem;
  width: 98%;
  font-family: "Exo 2", sans-serif;
}
li:nth-child(1) {
  margin-left: 1rem;
  font-weight: 600;
}
li:nth-child(2) {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 1.4rem;
  /* width: 98%; */
}
.info {
  font-size: 1rem;
  font-weight: bold;

  margin-right: 1rem;
  transition-duration: 0.2s;
}
.icon {
  margin: 1rem 0.5rem;
  cursor: pointer;
  transition-duration: 0.2s;
}
.icon:hover,
.info:hover {
  transform: scale(1.1);
}
.tooltip {
  position: relative;
  display: inline-block;
  /* border-bottom: 1px dotted black; */
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 20rem;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: -50%;
  margin-left: -60px;
  font-size: 1rem;
}

.tooltip .tooltiptext::after {
  /* content: ""; */
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
